import Link from "next/link"

import Icon from "@components/common/Icon"
import { SOCIAL_MEDIA_FACEBOOK, SOCIAL_MEDIA_INSTAGRAM } from "@customer-config"

/**
 * shows social media links if configured
 */
const SocialLinks: React.FC = () => <div className="social-icons">
  {SOCIAL_MEDIA_INSTAGRAM && <Link aria-label="Instagram" href={SOCIAL_MEDIA_INSTAGRAM}><Icon name={"instagram"} /></Link>}
  {SOCIAL_MEDIA_FACEBOOK && <Link aria-label="Facebook" href={SOCIAL_MEDIA_FACEBOOK}><Icon name={"facebook"} /></Link>}
</div>

export default SocialLinks